module.exports = __webpack_public_path__ + "media/assets/blue-trash-62dd81ca8e582507f2c8cc6d49caf5fc40600f689c39c9eb9180f9033b84367d.svg";